import { StudentWithProps } from '../hooks/useGetStudents';

/** Profile sections a student needs before they can be enrolled. */
export const missingProfileItems = (student: StudentWithProps): string[] => {
  const missing: string[] = [];
  if (!student.additionalGuardians?.length)
    missing.push('an additional guardian');
  if (!student.emergencyContacts?.length) missing.push('an emergency contact');
  if (!student.medicalInfo?.id) missing.push('medical information');
  if (!student.sharingInfo?.id) missing.push('information-sharing consent');
  return missing;
};

export const qualified = (student: StudentWithProps) =>
  !!student.id && missingProfileItems(student).length === 0;

/** Joins items as "a", "a and b" or "a, b and c". */
export const joinList = (items: string[]): string =>
  items.length <= 1
    ? items.join('')
    : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
